<template>
    <div>	
        <label v-if="showLabel" class="form-label mt-3">Teléfono:</label>	
        <input type="tel" id="focusPhone" attr-id="nickname" class="form-control form-control-lg" v-model="phone" @keyup="validatePhone" @blur="validatePhone">					 
    </div>
</template>
<script>
import 'intl-tel-input/build/css/intlTelInput.css';
import 'intl-tel-input/build/js/intlTelInput.js';
import intlTelInput from 'intl-tel-input';
export default { 
    props:['showLabel', 'phoneShow'],
    name: "input-phone-login",
    data(){
        return{
            isPhone: '0',
            phone: '',
            userPhone: '', 
            phoneInput: ''
        }
    },
    mounted: function () {
        if(this.phoneShow){
            this.phone = this.phoneShow;
        }
        
        const telInput = document.querySelector("[attr-id='nickname']");
       this.phoneInput = intlTelInput(telInput, {
        // any initialisation options go here
            preferredCountries: ["ar", "cl", "co", "mx", "pe", "uy", "br", "es", "ec", "us"],
            nationalMode: true,
            autoFormat: true,
            //formatOnDisplay: true,
            customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
                var textPlaceholder = 'Ej: ' + selectedCountryPlaceholder;
                if(selectedCountryData.iso2 == 'ar'){
                    textPlaceholder = "Ej: 11 4444-4444";
                }else if(selectedCountryData.iso2 == 'es'){
                    textPlaceholder = "Ej: 722 22 22 22";
                }else if(selectedCountryData.iso2 == 'mx'){
                    textPlaceholder = "Ej: 999 333 4444";
                }
                return textPlaceholder;
            },
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",            
        });  
        
        if(this.phoneInput){
            if(this.phoneShow){
                this.phone = this.phoneShow;
                const a = this;
                var element =  document.querySelector(".iti-load-utils");
                if (typeof(element) != 'undefined' && element != null){
                    setTimeout(function(){ a.validatePhone(); }, 200);
                }else{
                    try{
                        const plugUtils = document.querySelector(".iti-load-utils");
                        plugUtils.addEventListener('load', function() {
                            a.validatePhone();
                        })
                    }catch(e){
                        
                    } 
                }
            }
        }
    },
    methods:{  
        validatePhone(){
            var currentFormat = intlTelInputUtils.numberFormat.NATIONAL;
			if (this.phoneInput.getNumber()) {
				if (this.phoneInput.isValidNumber()) {
					this.isPhone = 1;
					this.phone = this.phoneInput.getNumber(currentFormat);
					this.userPhone = this.phoneInput.getNumber();
					//var getCode = this.phoneInput.getSelectedCountryData().dialCode;
				} else {
                    this.phone = this.phoneInput.getNumber(currentFormat);
					this.userPhone = this.phoneInput.getNumber();
					this.isPhone = 0;
				}
			}
            this.sendData();
        }, 
        sendData(){
            this.$parent.phoneNumber(this.isPhone, this.userPhone);
        }   
    }  
}
</script>
